export const TRANSACTION_PUT_START = "TRANSACTION_PUT_START";
export const TRANSACTION_PUT_SUCCESS = "TRANSACTION_PUT_SUCCESS";
export const TRANSACTION_PUT_ERROR = "TRANSACTION_PUT_ERROR";

export const WITHDRAW_START = "WITHDRAW_START";
export const WITHDRAW_SUCCESS = "WITHDRAW_SUCCESS";
export const WITHDRAW_ERROR = "WITHDRAW_ERROR";

export function transactionPutStart() {
  return { type: TRANSACTION_PUT_START };
}

export function transactionPutSuccess() {
  return { type: TRANSACTION_PUT_SUCCESS };
}

export function transactionPutError() {
  return { type: TRANSACTION_PUT_ERROR };
}

export function withdrawStart() {
  return { type: WITHDRAW_START };
}

export function withdrawSuccess() {
  return { type: WITHDRAW_SUCCESS };
}

export function withdrawError() {
  return { type: WITHDRAW_ERROR };
}
